import { z } from 'zod';
import type { SapStatus } from 'contracts/redirected-products';

export const formSchema = z.object({
  sapStatus: z.custom<SapStatus>().refine((value) => !!value, 'Selecione o status SAP'),
});

export type FormSchema = z.infer<typeof formSchema>